<div class="item-list-params-grid" [class.md-grid]="itemLimit == 6" [class.sm-grid]="itemLimit == 4">

  @for(item of attributes | slice:0:itemLimit; track item.code){
  <div class="grid-item">
    <div class="label"><span>{{item.name}}</span></div>
    <div class="value"><span>{{item.value}}</span></div>
  </div>
  }

</div>
